/** The same controls work on Explorer maps and live maps. */
export function bindDebugControls(renderer, root = document) {
    const welcomeControls = root.getElementById('welcome-controls');
    if (welcomeControls) welcomeControls.onclick = event => {
        event.preventDefault();
        const controls = root.getElementById('keybinds');
        controls.open = true; controls.querySelector('summary').focus();
    };
    const button = root.getElementById('diagnostics-toggle'), card = root.getElementById('diagnostics');
    const show = visible => { card.hidden = !visible; button.setAttribute('aria-expanded', String(visible)); };
    button.onclick = () => show(card.hidden);
    root.getElementById('diagnostics-close').onclick = () => { show(false); button.focus(); };
    for (const checkbox of card.querySelectorAll('[data-debug]')) checkbox.onchange = () => {
        const options = Object.fromEntries([...card.querySelectorAll('[data-debug]')].map(input => [input.dataset.debug, input.checked]));
        renderer?.setDebug(options);
    };
    card.onkeydown = event => { if (event.key === 'Escape') { show(false); button.focus(); } };
}
